(() => {
  const isMobile = () => window.innerWidth <= 768;

  const PRODUCT_SLIDER_SELECTOR = "#product-list-slider, .product-list-slider";
  const PRODUCT_CARD_SELECTOR = ".product-list-slider-card";
  const EXPANDED_CLASS = "is-expanded";

  const SECTION_FOUR_SELECTOR = '[handle="section-4"]';
  const SECTION_FOUR_BUTTON_SELECTOR = '[handle="section-4-js-load-more-btn"]';
  const SECTION_FOUR_COLLAPSED_COUNT = 4;

  const SECTION_THREE_SELECTOR = '[handle="section-3"]';
  const SECTION_THREE_SLIDE_SELECTOR = "[data-embla-slide]";
  const SECTION_THREE_COLLAPSED_COUNT = 4;
  const SECTION_THREE_BUTTON_HANDLE = "section-3-js-load-more-btn";

  const SECTION_NINE_SELECTOR = '[handle="section-9"]';
  const SECTION_NINE_SLIDE_SELECTOR = "[data-embla-slide]";
  const SECTION_NINE_COLLAPSED_COUNT = 4;
  const SECTION_NINE_BUTTON_HANDLE = "section-9-js-load-more";

  const SECTION_SIX_SELECTOR = '[handle="section-6"]';
  const SECTION_SIX_TABS_SELECTOR = '[handle="tabs"]';
  const SECTION_SIX_SLIDE_SELECTOR = "[data-embla-slide]";
  const SECTION_SIX_ACTIVE_TAB_CLASS = "is-active";
  const SECTION_SIX_HIDDEN_SLIDE_CLASS = "is-hidden";
  const SECTION_SIX_COLLAPSED_COUNT_MB = 4;
  const SECTION_SIX_COLLAPSED_COUNT_PC = 8;
  const SECTION_SIX_BUTTON_HANDLES = [
    "embla-slide-1-js-load-more-btn",
    "embla-slide-2-js-load-more-btn",
    "embla-slide-3-js-load-more-btn",
    "embla-slide-4-js-load-more-btn",
  ];

  const LOAD_MORE_TEXT = "Load More";
  const LESS_TEXT = "Less";

  function updateToggleState(target, button, isExpanded) {
    target.classList.toggle(EXPANDED_CLASS, isExpanded);
    button.textContent = isExpanded ? LESS_TEXT : LOAD_MORE_TEXT;
    button.setAttribute("aria-expanded", String(isExpanded));
  }

  function initLoadMore({
    target,
    slider,
    button,
    collapsedCount,
    collapsedCountMb,
    collapsedCountPc,
  }) {
    if (
      !(target instanceof HTMLElement) ||
      !(slider instanceof HTMLElement) ||
      !(button instanceof HTMLElement)
    ) {
      return;
    }

    const cards = slider.querySelectorAll(PRODUCT_CARD_SELECTOR);
    let isExpanded = false;

    const getCollapsedCount = () => {
      if (typeof collapsedCount === "number") return collapsedCount;
      if (
        typeof collapsedCountMb === "number" &&
        typeof collapsedCountPc === "number"
      ) {
        return isMobile() ? collapsedCountMb : collapsedCountPc;
      }
      return 0;
    };

    const syncButtonVisibility = () => {
      const currentCollapsedCount = getCollapsedCount();
      const shouldHideButton = cards.length <= currentCollapsedCount;

      button.style.display = shouldHideButton ? "none" : "";

      if (shouldHideButton) {
        isExpanded = false;
      }

      updateToggleState(target, button, isExpanded);
    };

    syncButtonVisibility();

    button.addEventListener("click", (event) => {
      event.preventDefault();
      if (button.style.display === "none") return;
      isExpanded = !isExpanded;
      updateToggleState(target, button, isExpanded);
      window.dispatchEvent(new Event("resize"));
    });

    window.addEventListener("resize", syncButtonVisibility);
  }

  function initSectionFourLoadMore() {
    const section = document.querySelector(SECTION_FOUR_SELECTOR);
    if (!(section instanceof HTMLElement)) return;

    const slider = section.querySelector(PRODUCT_SLIDER_SELECTOR);
    const button = section.querySelector(SECTION_FOUR_BUTTON_SELECTOR);

    initLoadMore({
      target: section,
      slider,
      button,
      collapsedCount: SECTION_FOUR_COLLAPSED_COUNT,
    });
  }

  function getEmblaSlides(section, selector) {
    return Array.from(section.querySelectorAll(selector)).filter(
      (element) => element instanceof HTMLElement,
    );
  }

  function getSlideLoadMoreButton(slide, section, buttonHandle) {
    if (buttonHandle) {
      const matchedInSlide = slide.querySelector(`[handle="${buttonHandle}"]`);
      if (matchedInSlide instanceof HTMLElement) return matchedInSlide;

      const matchedInSection = section.querySelector(`[handle="${buttonHandle}"]`);
      if (matchedInSection instanceof HTMLElement) return matchedInSection;
    }

    const fallbackInSlide = slide.querySelector('[handle$="-js-load-more-btn"]');
    if (fallbackInSlide instanceof HTMLElement) return fallbackInSlide;

    return null;
  }

  function initSectionLoadMore({
    sectionSelector,
    slideSelector,
    buttonHandle,
    collapsedCountMb,
    collapsedCountPc,
  }) {
    const section = document.querySelector(sectionSelector);
    if (!(section instanceof HTMLElement)) return;

    const slides = getEmblaSlides(section, slideSelector);
    if (!slides.length) {
      const slider = section.querySelector(PRODUCT_SLIDER_SELECTOR);
      const button =
        section.querySelector(`[handle="${buttonHandle}"]`) ??
        section.querySelector('[handle$="-js-load-more-btn"]');

      initLoadMore({
        target: section,
        slider,
        button,
        collapsedCountMb,
        collapsedCountPc,
      });
      return;
    }

    slides.forEach((slide) => {
      const slider = slide.querySelector(PRODUCT_SLIDER_SELECTOR);
      const button = getSlideLoadMoreButton(slide, section, buttonHandle);

      initLoadMore({
        target: slide,
        slider,
        button,
        collapsedCountMb,
        collapsedCountPc,
      });
    });
  }

  function initSectionThreeLoadMore() {
    initSectionLoadMore({
      sectionSelector: SECTION_THREE_SELECTOR,
      slideSelector: SECTION_THREE_SLIDE_SELECTOR,
      buttonHandle: SECTION_THREE_BUTTON_HANDLE,
      collapsedCountMb: SECTION_THREE_COLLAPSED_COUNT,
      collapsedCountPc: Number.MAX_SAFE_INTEGER,
    });
  }

  function initSectionNineLoadMore() {
    initSectionLoadMore({
      sectionSelector: SECTION_NINE_SELECTOR,
      slideSelector: SECTION_NINE_SLIDE_SELECTOR,
      buttonHandle: SECTION_NINE_BUTTON_HANDLE,
      collapsedCountMb: SECTION_NINE_COLLAPSED_COUNT,
      collapsedCountPc: Number.MAX_SAFE_INTEGER,
    });
  }

  function getSectionSixTabs(section) {
    const tabsContainer = section.querySelector(SECTION_SIX_TABS_SELECTOR);
    if (!(tabsContainer instanceof HTMLElement)) return [];

    return Array.from(tabsContainer.children).filter(
      (element) => element instanceof HTMLElement,
    );
  }

  function getVisibleElements(elements) {
    return elements.filter((element) => {
      const style = window.getComputedStyle(element);
      return style.display !== "none" && style.visibility !== "hidden";
    });
  }

  function getSectionSixSlides(section) {
    return getEmblaSlides(section, SECTION_SIX_SLIDE_SELECTOR);
  }

  function resetSectionSixEmblaPosition(section) {
    const emblaContainer = section.querySelector("[data-embla-container]");
    if (emblaContainer instanceof HTMLElement) {
      emblaContainer.style.transform = "translate3d(0px, 0px, 0px)";
    }
  }

  function setSectionSixActiveSlide(section, tabs, slides, activeIndex) {
    const visibleTabs = getVisibleElements(tabs);

    tabs.forEach((tab) => {
      tab.classList.remove(SECTION_SIX_ACTIVE_TAB_CLASS);
      tab.setAttribute("aria-selected", "false");
    });

    visibleTabs.forEach((tab, index) => {
      const isActive = index === activeIndex;
      tab.classList.toggle(SECTION_SIX_ACTIVE_TAB_CLASS, isActive);
      tab.setAttribute("aria-selected", String(isActive));
    });

    slides.forEach((slide, index) => {
      slide.classList.toggle(SECTION_SIX_HIDDEN_SLIDE_CLASS, index !== activeIndex);
    });

    resetSectionSixEmblaPosition(section);
    window.dispatchEvent(new Event("resize"));
  }

  function initSectionSixTabsAndLoadMore() {
    const section = document.querySelector(SECTION_SIX_SELECTOR);
    if (!(section instanceof HTMLElement)) return;

    const tabs = getSectionSixTabs(section);
    const slides = getSectionSixSlides(section);
    let activeSlideIndex = 0;

    if (!tabs.length || !slides.length) return;

    slides.forEach((slide, index) => {
      const slider = slide.querySelector(PRODUCT_SLIDER_SELECTOR);
      const button = getSlideLoadMoreButton(
        slide,
        section,
        SECTION_SIX_BUTTON_HANDLES[index],
      );

      initLoadMore({
        target: slide,
        slider,
        button,
        collapsedCountMb: SECTION_SIX_COLLAPSED_COUNT_MB,
        collapsedCountPc: SECTION_SIX_COLLAPSED_COUNT_PC,
      });
    });

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", (event) => {
        event.preventDefault();

        const visibleTabs = getVisibleElements(tabs);
        const visibleIndex = visibleTabs.indexOf(tab);

        if (visibleIndex === -1 || visibleIndex >= slides.length) return;

        activeSlideIndex = visibleIndex;
        setSectionSixActiveSlide(section, tabs, slides, activeSlideIndex);
      });
    });

    window.addEventListener("resize", () => {
      setSectionSixActiveSlide(section, tabs, slides, activeSlideIndex);
    });

    setSectionSixActiveSlide(section, tabs, slides, activeSlideIndex);
  }

  function init() {
    initSectionFourLoadMore();
    initSectionThreeLoadMore();
    initSectionNineLoadMore();
    initSectionSixTabsAndLoadMore();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
